import { InjectionToken } from "@angular/core";
import { environment } from "src/environments/environment";

export type Product = "talkbi" | "houseclaw";

export interface ProductBrand {
  product: Product;
  name: string;
  logo: string;
  favicon: string;
  appleTouchIcon?: string;
  supportEmail?: string;
}

export const PRODUCT_BRANDS: Record<Product, ProductBrand> = {
  talkbi: {
    product: "talkbi",
    name: "Talk BI",
    logo: "assets/logo.svg",
    favicon: "assets/favicon.ico",
  },
  houseclaw: {
    product: "houseclaw",
    name: "HouseClaw",
    logo: "assets/houseclaw/logo.png",
    favicon: "assets/houseclaw/favicon.ico",
    appleTouchIcon: "assets/houseclaw/apple-touch-icon.png",
    supportEmail: "hello@houseclaw.eu",
  },
};

/**
 * The same build serves app.talk.bi and app.houseclaw.eu. With `environment.product` set to "auto" the hostname decides;
 * "talkbi" or "houseclaw" pins one product, which is how `npm run start:houseclaw` works on localhost.
 */
export function detectProduct(hostname: string = window.location.hostname, setting: string = environment.product): Product {
  if (setting === "houseclaw" || setting === "talkbi") {
    return setting;
  }

  return hostname.toLowerCase().split(".").includes("houseclaw") ? "houseclaw" : "talkbi";
}

export const PRODUCT_BRAND = new InjectionToken<ProductBrand>("PRODUCT_BRAND", {
  providedIn: "root",
  factory: (): ProductBrand => PRODUCT_BRANDS[detectProduct()],
});

/** Runs before bootstrap so the tab never flashes the other product's name or icon. */
export function applyProductBranding(doc: Document, brand: ProductBrand): void {
  doc.title = brand.name;
  doc.documentElement.dataset["product"] = brand.product;
  doc.querySelector<HTMLLinkElement>('link[rel="icon"]')?.setAttribute("href", brand.favicon);

  if (brand.appleTouchIcon) {
    const link = doc.createElement("link");
    link.rel = "apple-touch-icon";
    link.href = brand.appleTouchIcon;
    doc.head.append(link);
  }
}
